import i18n from "@/locales/i18n";
import { checkAsset } from "@/utils/transactions/ExchangeCurrencies";

export function getAccountsWithSameAsset(
  accounts: any[],
  counterparty: any,
  rail: string,
) {
  if (rail === "SWIFT") {
    return accounts.filter(
      (account) =>
        checkAsset(account.assetTypeId) === "USD" && account.status === "OPEN",
    );
  } else {
    return accounts.filter(
      (account) =>
        checkAsset(account.assetTypeId) ===
          checkAsset(
            counterparty.walletInformation?.assetTypeId ||
              counterparty.accountInformation?.assetTypeId,
          ) && account.status === "OPEN",
    );
  }
}

export function getAmountFormattedBaseOnAssetType(
  amount: number,
  assetType: string,
  rail: string,
) {
  if (rail === "CRYPTO") {
    return `${checkAsset(assetType)} ${amount}`;
  } else {
    return `${checkAsset(assetType)} ${new Intl.NumberFormat(i18n.language, {
      style: "currency",
      currency: "USD",
    }).format(amount)}`;
  }
}
